<template>
    <div v-if="isRange" class="grid-content">
        <div class="grid-item">
            <r-input
                :value="min"
                :validate="validate"
                :placeholder="placeholder"
                @input="updateMin"
                left-label="Min"/>
        </div>
        <div class="grid-item">
            <r-input
                :value="max"
                :validate="validate"
                :placeholder="placeholder"
                @input="updateMax"
                left-label="Max"/>
        </div>
    </div>
    <div v-else>
        <r-input
            :value="min"
            :validate="validate"
            :placeholder="placeholder"
            @input="updateMin"/>
    </div>
</template>

<script>
    import BaseEditor from '@/components/query2/components/editors/base-editor';
    import isBlank from '@/common/helpers/is-blank';
    import QueryLine from '@/components/query2/query-line';

    export default {
        name: 'numeric-editor',
        extends: BaseEditor,
        computed: {
            isRange() {
                return this.item.isRange;
            },
        },
        watch: {
            'item.operator': function update() {
                // update the values when switching between operators
                this.dispatchUpdate();
            },
        },
        data() {
            const values = this.item.getValues();
            let min = null;
            let max = null;
            if (values) {
                [min, max] = values;
                if (this.item.operator === QueryLine.Operators.isLTE) {
                    // LTE returns max only, set it as min and nullify max
                    min = max;
                    max = null;
                }
            }
            return {
                min,
                max,
                placeholder: 'Enter a value',
            };
        },
        methods: {
            updateMin(min) {
                this.min = min;
                this.dispatchUpdate();
            },
            updateMax(max) {
                this.max = max;
                this.dispatchUpdate();
            },
            encodeData() {
                let data = [this.min];
                if (this.isRange) {
                    data = [this.min, this.max];
                }
                return data.map(v => (isBlank(v) ? null : v));
            },
        },
    };
</script>
